var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 80,
    viewBox: "0 0 96 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7323 17.2461V19.539L48 45.443V43.1501L78.7323 17.2461Z",
    fill: "#212122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0972 37.2725V39.5654L48 45.4525V43.1596L95.0972 37.2725Z",
    fill: "#212122"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4053 7.3252V9.61812L47.4245 43.438V41.1451L47.4053 7.3252Z",
    fill: "#212122"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.898438 37.2915V39.5844L48.0005 45.4524V43.1595L0.898438 37.2915Z",
    fill: "#212122"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9912 9.34185C58.7682 9.09221 69.4042 11.8277 78.7235 17.2458V19.5387C69.4042 14.1206 58.7682 11.3851 47.9912 11.6348V9.34185Z",
    fill: "#212122"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7323 17.2485V19.5415L48 45.443V43.1621L78.7323 17.2485Z",
    fill: "#212122"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4094 60.0841V62.3698L48 45.455V43.1621L89.4094 60.0841Z",
    fill: "#212122"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.249 17.2554V19.5483L48.0005 45.4499V43.1617L17.249 17.2554Z",
    fill: "#212122"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58105 60.0721V62.3698L48 45.4598V43.1621L6.58105 60.0721Z",
    fill: "#212122"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7305 17.2485C87.7245 22.5811 93.0522 29.1021 95.0954 37.275V39.5679C93.0522 31.4046 87.7221 24.874 78.7305 19.5415V17.2485Z",
    fill: "#212122"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.898438 37.2939C2.93445 29.1306 8.25738 22.5976 17.2466 17.2603V19.5532C8.25738 24.8905 2.93445 31.4115 0.898438 39.5868V37.2939Z",
    fill: "#212122"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.898438 37.2915V39.5844L48.0005 45.4524V43.1595L0.898438 37.2915Z",
    fill: "#212122"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6309 74.9388V77.2317L47.9958 45.455V43.1621L31.6309 74.9388Z",
    fill: "#212122"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0972 37.2725V39.5654L48 45.4525V43.1596L95.0972 37.2725Z",
    fill: "#212122"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3458 74.9436V77.2365L48 45.455V43.1621L64.3458 74.9436Z",
    fill: "#212122"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58154 60.0694C2.4519 55.4046 0.172468 49.3896 0.173377 43.1595V45.4524C0.160027 43.4735 0.40213 41.5013 0.893672 39.5844V37.2915C0.402104 39.2083 0.160001 41.1806 0.173377 43.1595V45.4524C0.172468 51.6825 2.4519 57.6975 6.58154 62.3623V60.0694Z",
    fill: "#212122"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8279 43.1621C95.8285 49.3975 93.5454 55.4172 89.4102 60.0841V62.3698C93.5456 57.703 95.8287 51.6832 95.8279 45.4478V43.1621Z",
    fill: "#212122"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58105 60.0721V62.3698L48 45.4598V43.1621L6.58105 60.0721Z",
    fill: "#212122"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3458 74.9436V77.2365L48 45.455V43.1621L64.3458 74.9436Z",
    fill: "#212122"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4094 60.0841V62.3698L48 45.455V43.1621L89.4094 60.0841Z",
    fill: "#212122"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.626 74.9412V77.2341L47.9885 45.455V43.1621L31.626 74.9412Z",
    fill: "#212122"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6375 74.9385C20.6098 72.0981 12.4514 67.2554 6.58105 60.0693V62.3623C12.449 69.5507 20.6074 74.3911 31.6375 77.2314V74.9385Z",
    fill: "#212122"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4094 60.0815C83.5366 67.2676 75.3757 72.1056 64.3457 74.9435V77.2364C75.3757 74.4009 83.5366 69.5533 89.4094 62.3745V60.0815Z",
    fill: "#212122"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.346 74.9482C53.6279 77.786 42.3558 77.786 31.6377 74.9482V77.2412C42.3558 80.079 53.6279 80.079 64.346 77.2412V74.9482Z",
    fill: "#212122"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9912 9.34185C58.7682 9.09221 69.4042 11.8277 78.7235 17.2458L47.9912 43.1594V9.34185Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7323 17.2461C87.7263 22.5786 93.054 29.0996 95.0972 37.2725L48 43.1597L78.7323 17.2461Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0972 37.2725C96.1197 41.2474 96.1353 45.4144 95.1427 49.3969C94.15 53.3794 92.1803 57.0516 89.4117 60.0816L48 43.1596L95.0972 37.2725Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4094 60.0841C83.5366 67.2702 75.3758 72.1081 64.3458 74.946L48 43.1621L89.4094 60.0841Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.346 74.9436C53.6279 77.7814 42.3558 77.7814 31.6377 74.9436L48.0002 43.1621L64.346 74.9436Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6374 74.9388C20.6098 72.0985 12.4514 67.2558 6.58105 60.0697L48 43.1621L31.6374 74.9388Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58142 60.0719C3.81797 57.0452 1.85149 53.3782 0.859335 49.4016C-0.132814 45.4251 -0.119406 41.264 0.898353 37.2939L48.0004 43.1619L6.58142 60.0719Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0.898438 37.2939C2.93445 29.1306 8.25738 22.5976 17.2466 17.2603L48.0005 43.1618L0.898438 37.2939Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2715 8.03613V10.3291L45.023 36.2306V33.9377L14.2715 8.03613Z",
    fill: "#4F0C84"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2715 8.04078C23.5884 2.615 34.2249 -0.127212 45.0038 0.117609V2.41053C34.2249 2.16571 23.5884 4.90792 14.2715 10.3337V8.04078Z",
    fill: "#4F0C84"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2715 8.04078C23.5884 2.615 34.2249 -0.127212 45.0038 0.117609L45.023 33.9375L14.2715 8.04078Z",
    fill: "#4F0C84",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart4);
export default __webpack_public_path__ + "static/media/Chart4.dc1b144b657fc95a395d1a6361fb638c.svg";
export { ForwardRef as ReactComponent };